import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext'; // Adjust based on your context structure

const PrivateRoute = () => {
  const { isAuthenticated } = useAuth(); // Assume this returns the logged-in user or null
  const location = useLocation(); // Get the current location (route)

  // If the user is not authenticated, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} />; // Passing the current route to the login page
  }

  return <Outlet />;
};

export default PrivateRoute;